import { render, staticRenderFns } from "./courseLearningRateXbk.vue?vue&type=template&id=040c2a4e&scoped=true"
import script from "./courseLearningRateXbk.vue?vue&type=script&lang=js"
export * from "./courseLearningRateXbk.vue?vue&type=script&lang=js"
import style0 from "./courseLearningRateXbk.vue?vue&type=style&index=0&id=040c2a4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c2a4e",
  null
  
)

export default component.exports